import React, { useState, useEffect } from "react";
import { ref, onValue, set } from "firebase/database";
import { db } from "../firebaseConfig";

const PendingRequests = () => {
  const [workspaces, setWorkspaces] = useState({});
  const [selectedKey, setSelectedKey] = useState("");
  const [pendingRequest, setPendingRequest] = useState({});
  const [assignRequest, setAssignRequest] = useState(null); 
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [nameError, setNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState(""); 

  useEffect(() => {
    const workspacesRef = ref(db, "neoslide/workspaces");
    onValue(workspacesRef, (snapshot) => {
      if (snapshot.exists()) {
        setWorkspaces(snapshot.val());
      }
    });

    const pendingRef = ref(db, "neoslide/pendingRequest");
    onValue(pendingRef, (snapshot) => {
      if (snapshot.exists()) {
        setPendingRequest(snapshot.val());
      } else {
        setPendingRequest({});
      }
    });
  }, []);

  const selectedWorkspace = workspaces[selectedKey] || "";
  const selectedPendingRequests = pendingRequest[selectedWorkspace] || {};

  const handleAssign = (device) => {
    setAssignRequest(device);
    setName("");
    setDescription("");
    setNameError(""); 
    setDescriptionError("");
  };

  const handleSubmit = () => {
    let valid = true;

    if (!name.trim()) {
      setNameError("Name is required");
      valid = false;
    } else {
      setNameError("");
    }

    if (!description.trim()) {
      setDescriptionError("Description is required");
      valid = false;
    } else {
      setDescriptionError("");
    }

    if (!valid) return; 

    if (!assignRequest || !selectedWorkspace) return;

    const deviceRef = ref(db, `neoslide/devices/${selectedWorkspace}/${assignRequest}`);
    const pendingRequestRef = ref(db, `neoslide/pendingRequest/${selectedWorkspace}/${assignRequest}`);

    set(deviceRef, {
      deviceId: assignRequest,
      name,
      description,
      workspaceId: selectedWorkspace,
    }).then(() => {
      set(pendingRequestRef, null).then(() => {
        setAssignRequest(null);
      });
    });
  };

  return (
    <div className="workspaces-container">
      <h2>Pending Requests</h2>
      <select value={selectedKey} onChange={(e) => setSelectedKey(e.target.value)}>
        <option value="">-- Select Workspace --</option>
        {Object.entries(workspaces).map(([key, name]) => (
          <option key={key} value={key}>
            {name}
          </option>
        ))}
      </select>
      {selectedKey && selectedWorkspace && Object.keys(selectedPendingRequests).length > 0 ? (
        <table className="devices-table">
          <thead>
            <tr>
              <th>Device ID</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(selectedPendingRequests).map(([key, value]) => (
              <tr key={key}>
                <td>{value}</td>
                <td>
                  <button onClick={() => handleAssign(value)}>Assign</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : selectedKey && selectedWorkspace ? (
        <p>No pending requests for this workspace.</p>
      ) : null}
      {assignRequest && (
        <div className="edit-popup">
          <div className="edit-content">
            <h3>Assign Device</h3>
            <p><strong>Device ID:</strong> {assignRequest}</p>
            <label>
              Name:
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
              {nameError && <p className="error-message">{nameError}</p>} 
            </label>
            <label>
              Description:
              <input type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
              {descriptionError && <p className="error-message">{descriptionError}</p>}
            </label>
            <p><strong>Workspace ID:</strong> {selectedWorkspace}</p>
            <div className="buttons">
              <button className="popup__button" onClick={handleSubmit}>Submit</button>
              <button className="popup__button-cancel" onClick={() => setAssignRequest(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingRequests;
